<template>
    <v-card>
        <v-card-title>
            <h3>Dodatkowi terapeuci</h3>
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                            Imię i nazwisko
                                        </th>
                                        <th class="text-left">
                                            Typ wizyty
                                        </th>                                        
                                        <th class="text-left">
                                            Akcje
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="therapist in additionalTherapists" :key="therapist.id">
                                        <td>{{ therapist.name }}</td>
                                        <td>{{ therapist.typWizyty }}</td>
                                        <td>
                                            <v-icon small class="mr-2" @click="removeTherapist(therapist)">
                                                fa-trash
                                            </v-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" lg="6" md="6">
                        <v-select :items="availableTherapists" item-text="name" item-value="id" clearable label="Terapeuta"
                          placeholder="Wybierz terapeute.." v-model="selectedTherapist" name="therapist" id="therapist">
                          <template v-slot:item="data">
                                <div>{{ data.item.name + (data.item.reason ? ' (' + data.item.reason + ')' : '') }}
                                </div>
                              </template>
                              <template v-slot:selection="data">
                                <div>{{ data.item.name + (data.item.reason ? ' (' + data.item.reason + ')' : '') }}
                                </div>
                              </template>                            
                            <template slot="append-outer">
                                <v-btn fab small color="primary">
                                <v-icon  title="Dodaj terapeute" @click="addTherapist"
                                        v-if="$can('do','POKO_Wizyty_Edycja')">fa-plus</v-icon>
                                </v-btn>
                          </template>           
                        </v-select>
                    </v-col>
                </v-row>
                <v-row v-if="selectedTherapist > 0 && filteredtypywizyt.length > 0">
                            <v-col cols="6">
                              <v-select :items="filteredtypywizyt" item-text="nazwa" label="Typ wizyty terapeuty"
                                placeholder="Wybierz typ wizyty terapeuty..." v-model="selectedTypWizyty" return-object
                                clearable>
                                <template v-slot:selection="data">
                                  <div>{{ data.item.nazwa + ' - ' + data.item.cena + ' zł' }}</div>
                                </template>
                                <template v-slot:item="data">
                                  <div>{{ data.item.nazwa + ' - ' + data.item.cena + ' zł' }}</div>
                                </template>
                              </v-select>
                            </v-col>
                </v-row>                
            </v-container>
            <!-- Simple table for additional therapists -->

            <!-- Therapist autocomplete -->

        </v-card-text>
    </v-card>
</template>

<script>
import { therapistsService } from "@/services/";
import swal from "sweetalert";

export default {
    name: "VisitEditorAdditionalTherapists",
    props: {
        initialTherapists: {
            type: Array,
            default: () => []
        },
        mainTherapistId: {
            type: Number,
            default: null
        },
        therapistCheck: {
            type: Object,
            default: null
        },
        fullTherapistList: {
            type: Array,
            default: null
        },
        typywizyt: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            additionalTherapists: [],
            therapists: [],
            selectedTherapist: null,
            therapistKeyword: null,
            isLoadingTherapists: false,
            selectedTypWizyty: null,
            loading: false
        };
    },
    computed: {
        availableTherapists() {
            if (!this.fullTherapistList) return [];
            return this.fullTherapistList.filter(therapist => 
                !this.additionalTherapists.some(additional => additional.id === therapist.id)
            );
        },
        filteredtypywizyt: function () {
            if (this.selectedTherapist > 0) {
                let lst = []
                lst = this.typywizyt.map(obj => ({ ...obj, disabled: !obj.aktywna }))
                return lst.filter(x => x.terapeuta_id == this.selectedTherapist)
            }
            return []
        },
    },
    created() {
        // Initialize additional therapists from props
        this.additionalTherapists = [...this.initialTherapists];

        // Add initial therapists to the therapists list if they're not already there
        this.initialTherapists.forEach(therapist => {
            if (!this.therapists.find(t => t.id === therapist.id)) {
                this.therapists.push(therapist);
            }
        });
    },
    methods: {
        showError(isLoading, message) {
            if (isLoading) {
                this.loading = true;
            } else {
                this.loading = false;
            }
            swal({
                title: "Błąd",
                text: message,
                icon: "error",
                button: "OK"
            });
        },
        loadTherapists(val) {
            this.isLoadingTherapists = true;
            therapistsService
                .getAll({ query: val, page: 1, limit: 1000 })
                .then(response => {
                    if (
                        response.data != null &&
                        response.data.result != null &&
                        response.data.result.items != null
                    ) {
                        response.data.result.items.forEach((r, index) => {
                            if (!this.therapists.find(x => x.id === r.id) && r.id !== this.mainTherapistId) {
                                this.therapists.push({
                                    id: r.id,
                                    name: r.name + " " + r.surname
                                });
                            }
                        });
                        this.isLoadingTherapists = false;
                        this.calcTherapistCheck()
                    } else {
                        throw "error pobierania terapeutów";
                    }
                })
                .catch(e => {
                    this.isLoadingTherapists = false;
                    this.showError(true, "Nie można pobrać listy terapeutów.");
                });
        },
        addTherapist() {        
            if(this.selectedTherapist == null) return;

            // Check if visit types are available and if one is selected
            if (this.typywizyt && this.typywizyt.length > 0 && !this.selectedTypWizyty) {
                this.showError(false, "Wybierz typ wizyty przed dodaniem terapeuty");
                return;
            }
            
            let therapist = this.fullTherapistList.find(t => t.id === this.selectedTherapist);
            
            if (therapist && !this.additionalTherapists.find(t => t.id === therapist.id)) {
                // Add visit type information to the therapist object            
                const therapistWithVisitType = {
                    ...therapist,
                    typWizyty: this.selectedTypWizyty ? this.selectedTypWizyty.nazwa : null,
                    typWizytyId: this.selectedTypWizyty ? this.selectedTypWizyty.id : null
                };
                
                this.additionalTherapists.push(therapistWithVisitType);
                this.selectedTherapist = null;
                this.$emit('therapists-updated', [...this.additionalTherapists]);
            }
        },
        removeTherapist(item) {
            const index = this.additionalTherapists.findIndex(t => t.id === item.id);
            if (index > -1) {
                this.additionalTherapists.splice(index, 1);
                this.$emit('therapists-updated', [...this.additionalTherapists]);
            }
        },
        calcTherapistCheck() {
            if (this.therapistCheck && this.therapistCheck.length > 0) {
                this.therapistCheck.forEach(itm => {
                    let t = this.therapists.find(x => x.id == itm.therapistId);
                    if (t) {
                        t.disabled = itm.type === 'Harmonogram' ? false : true
                        t.reason = itm.type
                    }
                });
            }
        }
    },
    watch: {
        therapistKeyword(val) {
            if (val) {
                this.loadTherapists(val);
            }
        },
        initialTherapists: {
            handler(newVal) {
                this.additionalTherapists = [...newVal];
            },
            deep: true
        },
        therapistCheck: {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    newVal.forEach(itm => {
                let t = this.therapists.find(x => x.id == itm.therapistId);

                if (t) {

                  t.disabled = itm.type === 'Harmonogram' ? false : true
                  t.reason = itm.type
                  if (this.therapistId > 0) {
                    let s = this.therapistId
                    this.therapistId = 0
                    this.therapistId = s
                  }
                }
              })
            }
            },
            deep: true
        }
    }
};
</script>
